module.exports = __webpack_public_path__ + "fonts/DirtyBrush.2e97bf8.woff";